<template>
  <div id="stats">
    <div id="forward-movement" class="purple-box">
      <div class="area-header --uppercase">
        <a 
          href="https://www.guidetofm.com/tactics/choosing-roles-duties/#general-considerations" 
          target="_blank"
        >
          {{ $t('ui.forwardMovementScores') }} &gt;
        </a>
      </div>

      <template v-for="score in scores">
        <div class="data-table-row" :key="score.id">
          <div class="--capitalise">{{ $t(score.name) }}</div>
          <RatedScore
              :actualScore="forwardMovementScores[score.id].score"
              :targetScore="forwardMovementScores[score.id].target"
          />
        </div>
        <template v-for="side in sides">
          <div class="data-table-row sub-row" :key="score.id + side">
            <div class="--capitalise-first-letter">{{ $t('stats.forwardMovement.' + side) }}</div>
            <RatedScore
                :actualScore="forwardMovementScores[score.id][side]"
                :targetScore="forwardMovementScores[score.id].target"
            />
          </div>
        </template>
      </template>
    </div>
    <TheRiskIndicator />
    <ThePartnershipsCount />
    <ThePositionalResponsibilityAnalysis />
  </div>
</template>

<script>
import ThePositionalResponsibilityAnalysis from "@/components/ThePositionalResponsibilityAnalysis";
import ThePartnershipsCount from '@/components/ThePartnershipsCount.vue'
import TheRiskIndicator from "@/components/TheRiskIndicator.vue";
import RatedScore from '@/components/RatedScore.vue'

export default {
  components: {
    ThePositionalResponsibilityAnalysis,
    ThePartnershipsCount,
    TheRiskIndicator,
    RatedScore
  },
  
  data: function() {
    return {
      scores: {
        penetration: {
          name: "stats.forwardMovement.penetrationScore", 
          id: "penetration"
        },
        solidity: {
          name: "stats.forwardMovement.solidityScore",
          id: "solidity"
        },
        support: { 
          name: "stats.forwardMovement.supportScore", 
          id: "support"
        }
      },
      sides: ['left', 'right']
    }
  },

  computed: {
    forwardMovementScores () {
      return this.$store.getters.forwardMovementScores;
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 767px) {
  .mobile-hide {
    display: none;
  }
}
</style>
